<template>
  <div id="matches">
    <div v-for="(round, index) in matches">
      <div class="date">{{ round.fullname | translate }}</div>
      <Match v-for="(match, index2) in round.matches" :id="match.id" :key="match.id"></Match>
    </div>
  </div>
</template>

<script>
import Match from "@/components/domain/categories/Match";

export default {
  name: "Matches",
  props: { matches: Object, group: Object },
  components: { Match },
  data() {
    return {};
  },
  computed: {},
  methods: {
    load() {}
  },
  created() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
#matches {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 50px;

  .date {
    font-family: AvantGarde;
    text-align: left;
    font-size: 26px;
  }
}

@media only screen and (max-width: 600px) {
  #matches {
    .date {
      text-align: center;
      font-size: 16px;
    }
  }
}
</style>
